import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { CardHeader } from '../ui/CardHeader';
import { DisplayValue } from '../ui/DisplayValue';
import { MeterBar } from '../ui/MeterBar';
import { Pill } from '../ui/Pill';
import { SurfaceCard } from '../ui/SurfaceCard';
import type { WeatherView } from '../../weather/format';

interface SunCardProps {
  view: WeatherView;
  onOpenHistory: () => void;
}

export function SunCard({ view, onOpenHistory }: SunCardProps) {
  return (
    <SurfaceCard>
      <CardHeader title="Soare" onOpenHistory={onOpenHistory} />

      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'space-between',
          gap: '16px',
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
          <Typography
            component="span"
            sx={(theme) => ({ fontSize: 12, fontWeight: 500, color: theme.palette.weather.faint })}
          >
            Indice UV
          </Typography>
          <DisplayValue>{view.uvIndex}</DisplayValue>
        </Box>
        <Pill tone="accent">{view.uvLabel}</Pill>
      </Box>

      <MeterBar width={view.uvWidth} height={8} tone="accent" />

      <Typography sx={(theme) => ({ fontSize: 13, color: theme.palette.weather.soft })}>
        {view.uvAdvice}
      </Typography>

      <Box sx={(theme) => ({ height: '1px', backgroundColor: theme.palette.weather.line })} />

      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'space-between',
          gap: '16px',
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
          <Typography
            component="span"
            sx={(theme) => ({ fontSize: 12, fontWeight: 500, color: theme.palette.weather.faint })}
          >
            Iluminare
          </Typography>
          <DisplayValue>{view.illuminance}</DisplayValue>
        </Box>
        <Box
          sx={(theme) => ({
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            gap: '4px',
            fontSize: 13,
            color: theme.palette.weather.soft,
          })}
        >
          <Box component="span" sx={(theme) => ({ color: theme.palette.weather.ink, fontWeight: 500 })}>
            {view.solarRad}
          </Box>
          <span>{view.daylight}</span>
        </Box>
      </Box>
    </SurfaceCard>
  );
}
